import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie-player';

const PlayTextAnimation = () => {
  const [animationData, setAnimationData] = useState();

  useEffect(() => {
    import('../../assets/lottie/PlayRealmText.json').then(setAnimationData);
  }, []);

  if (!animationData) return <div className="realm" />;
  return (
    <Lottie
      animationData={animationData}
      background="transparent"
      play
      speed={1}
      loop={false}
      className="text play"
    />
  );
};

export default React.memo(PlayTextAnimation);
